import axios from 'axios';

if (!window.cy) {
  axios.defaults.baseURL = process.env.NX_API_BASE_URL;
  axios.defaults.timeout = 1000 * 60;
}

export default axios;
